export class PracticeFileUpload {
  id: number = null
  sort_no: number = null
  title: string = null
  is_publish: boolean = false
  is_personal: boolean = false
  is_personal_cache: boolean = false

  constructor(x: any = null){
    if(!x){
      return;
    }
    this.id = x.id;
    this.sort_no = x.sort_no;
    this.title = x.title;
    this.is_publish = x.is_publish;
    this.is_personal = x.is_personal;
    this.is_personal_cache = x.is_personal;
  }
}